import { PureComponent } from 'react';
import { criteria, fontFamily } from '../Consts';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2'
import annotationPlugin from 'chartjs-plugin-annotation';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin,
);

export class BarChartMultiple extends PureComponent {

    getColColorStd = (id) => {
        const factor = 20;
        const damper = 0;
        const rgb = [61 - damper, 255 - damper, 83 - damper];
        let colString = "rgba(" + (rgb[0] - id * factor) + "," +
            (rgb[1] - id * factor) + "," +
            // (rgb[1]) + "," +
            (rgb[2] - id * factor) +
            ",0.8)";
        return colString;
    }

    getKritBColors = (dc, dcw, c, idx, cp) => {
        let colors = [...dc];
        let af = 0;
        for (let i = 1; i < cp.length; i++) {
            if (cp[i] > 40) {
                af++;
            }
        }
        if (af > 0) {
            colors[idx] = c;
        }
        return colors;
    }

    render() {

        let colorvars = [];
        let i = -1;
        do {
            i++;
            let colorvar = getComputedStyle(document.documentElement).getPropertyValue(
                `--color-wheel-${i + 1}`,
            );
            if (colorvar.length) colorvars.push(colorvar);
        } while (typeof colorvars[i] !== 'undefined');

        const dF = this.props.evalData;
        const protoExam = dF[0][1];
        // console.log(dF);

        // console.log(dF);

        // const { numTasks, maxPoints, ...rest } = dF[0][0];
        const { numTasks } = dF[0][0];

        // const columnColorStd = "rgba(132, 133, 132, 0.5)"; // unused?
        // const columnColorAtt = "rgba(33, 33, 233, 0.8)";
        const columnColorAtt = colorvars[0];

        const xScaleColorStd = "rgba(100, 100, 100, 0.8)";
        // const xScaleColorAtt = "rgba(50, 203, 255, 0.8)";
        const xScaleColorAtt = colorvars[2];

        // should be variable, won't work... :/
        const barColorKritB = "rgba(127, 128, 134,1 )";

        // const barColorKritB = "rgba(186, 85, 211, 1)";

        let labels = [];
        // let dataColors = [];
        let xScaleColors = [];
        let xScaleColorsWeight = [];
        let xScaleColorsSize = [];

        // let strLegendKritC = "Kriterium c: relativer Abstand >20%";
        // if (this.props.parentState.criterion_c !== "yes") {
        //     strLegendKritC = "";
        // }

        for (let i = 0; i < numTasks; i++) {
            // labels[i] = protoExam["columns"][i + 2].label;
            labels[i] = protoExam["taskNames"][0][i + 2].value;
            if (Number(this.props.overallStats.aRelDistance[i]) > 20) {
                xScaleColors.push(xScaleColorAtt);
                xScaleColorsWeight.push("bold");
                xScaleColorsSize.push(20);
            }
            else {
                xScaleColors.push(xScaleColorStd);
                xScaleColorsWeight.push("normal");
                xScaleColorsSize.push(14);
            }
        }

        let dataSets = [];
        for (let e = 0; e < dF.length; e++) {
            // console.log(dF[e][1]);
            let dp = [];
            let dc = [];
            // let hbc = [];
            for (let t = 0; t < numTasks; t++) {
                let degOfSol = Number(dF[e][0].aDegOfSolution[t]);
                dp.push(degOfSol);
                // hbc.push("rgba(0,0,0,1)");
                if (degOfSol < 20 || degOfSol > 80) {
                    dc.push(columnColorAtt);
                }
                else {
                    dc.push(this.getColColorStd(e));
                }
            }

            dataSets.push({
                label: dF[e][1].klasse + " " + dF[e][1].fach + " " + dF[e][1].schuljahr,
                data: dp,
                backgroundColor: (barElement) => {
                    if (barElement.active === true && this.props.parentState.criterion_b === "yes") {
                        let colors = this.getKritBColors(
                            dc,
                            dc,
                            barColorKritB,
                            barElement.index,
                            // this.props.evalData[0].crossProducts[barElement.index],
                            this.props.evalData[e][0].crossProducts[barElement.index],
                        );
                        return colors;
                    }
                    else {
                        return dc;
                    }
                },
            })
        }

        const data = {
            labels,
            datasets: dataSets,
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            elements: {
                bar: {
                    inflateAmount: -3,
                },
            },
            scales: {
                x: {
                    ticks: {
                        color: xScaleColors,
                        font: {
                            family: fontFamily,
                            size: xScaleColorsSize,
                            weight: xScaleColorsWeight,
                        },
                    },
                },
                y: {
                    max: 100,
                    min: 0,
                },
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        title: (ctx) => {
                            return "Aufgabe " + ctx[0].label + " - Lösungsgrad: " + ctx[0].raw + "%";
                        },
                        label: (ctx) => {
                            if (this.props.parentState.criterion_b === "yes") {
                                let af = 0;
                                let cp = this.props.evalData[ctx.datasetIndex][0].crossProducts[ctx.dataIndex];
                                let rV = "Auffälligkeiten bei " + criteria[1] + " mit ";
                                for (let i = 1; i < cp.length; i++) {
                                    if (cp[i] > 40) {
                                        rV += protoExam["taskNames"][0][i + 1].value + " (" + cp[i] + "%), ";
                                        af++;
                                    }
                                }
                                if (af === 0) {
                                    rV = "Keine Auffälligkeiten bei " + criteria[1] + ".";
                                }
                                else {
                                    rV = rV.substring(0, rV.length - 2);
                                }
                                return rV;
                            }
                            else {
                                return ctx.dataset.label;
                            }
                        },
                    },
                },
                legend: {
                    position: 'top',
                    onClick: (evt, legendItem, legend) => {
                        const datasets = legend.legendItems.map((dataset, index) => {
                            return dataset.text;
                        })
                        const idx = datasets.indexOf(legendItem.text);
                        legend.chart.isDatasetVisible(idx) ? legend.chart.hide(idx) : legend.chart.show(idx);
                    },
                    labels: {
                        generateLabels: (chart) => {
                            let vis = [];
                            for (let i = 0; i < chart.data.datasets.length; i++) {
                                if (chart.isDatasetVisible(i) === false) {
                                    vis.push(true);
                                }
                                else {
                                    vis.push(false);
                                }
                            }

                            return chart.data.datasets.map(
                                (dataset, index) => ({
                                    text: dataset.label,
                                    fillStyle: this.getColColorStd(index),
                                    strokeStyle: "rgba(50, 205, 50, 0.8)",
                                    hidden: vis[index],
                                })
                            )
                        },
                        boxWidth: 20,
                    },
                },
                title: {
                    display: true,
                    text: "Durchschnitticher Lösungsgrad in den Klassen [%]",
                    color: 'grey',
                    font: {
                        size: 20,
                        family: fontFamily,
                        weight: 'normal',
                    },
                },
                annotation: {
                    annotations: {
                        line80: {
                            type: 'line',
                            yMin: 80,
                            yMax: 80,
                            borderColor: colorvars[0],
                            borderWidth: 1,
                            borderDash: [6, 3],
                        },
                        line20: {
                            type: 'line',
                            yMin: 20,
                            yMax: 20,
                            borderColor: colorvars[0],
                            borderWidth: 1,
                            borderDash: [6, 3],
                        },
                        labelEx80: {
                            type: 'label',
                            xValue: -0.42,
                            yValue: 90,
                            backgroundColor: 'transparent',
                            content: ['Extrembereich'],
                            rotation: -90,
                            textAlign: 'left',
                            color: colorvars[0],
                            font: {
                                size: 12,
                                family: fontFamily,
                            }
                        },
                        labelEx20: {
                            type: 'label',
                            xValue: -0.42,
                            yValue: 10,
                            backgroundColor: 'transparent',
                            content: ['Extrembereich'],
                            rotation: -90,
                            textAlign: 'left',
                            color: colorvars[0],

                            font: {
                                size: 12,
                                family: fontFamily,
                            }
                        },
                        labelNorm: {
                            type: 'label',
                            xValue: -0.42,
                            yValue: 50,
                            backgroundColor: 'transparent',
                            content: ['mittlere Lösungsgrade'],
                            rotation: -90,
                            textAlign: 'left',
                            color: 'grey',
                            font: {
                                size: 12,
                                family: fontFamily,
                            }
                        },
                    }
                },
            },
        };

        return (
            <div className="barSizer">
                <Bar options={options} data={data} />
            </div >
        )
    }
}

export default BarChartMultiple;
